import { Component } from '@angular/core';

@Component({
  selector: 'app-instagram-icon',
  standalone: true,
  template: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="white"/>
<path d="M15.2335 4H8.76649C6.13823 4 4 6.13823 4 8.76649V15.2335C4 17.8618 6.13823 20 8.76649 20H15.2335C17.8618 20 20 17.8618 20 15.2335V8.76649C20 6.13823 17.8617 4 15.2335 4ZM18.3904 15.2335C18.3904 16.977 16.977 18.3904 15.2335 18.3904H8.76649C7.023 18.3904 5.6096 16.977 5.6096 15.2335V8.76649C5.6096 7.02297 7.023 5.6096 8.76649 5.6096H15.2335C16.977 5.6096 18.3904 7.02297 18.3904 8.76649V15.2335Z" fill="url(#paint0_linear_4060_2829)"/>
<path d="M12 7.86182C9.7182 7.86182 7.86182 9.7182 7.86182 12C7.86182 14.2817 9.7182 16.1381 12 16.1381C14.2818 16.1381 16.1382 14.2817 16.1382 12C16.1382 9.71817 14.2818 7.86182 12 7.86182ZM12 14.5286C10.6035 14.5286 9.47142 13.3965 9.47142 12C9.47142 10.6035 10.6035 9.47142 12 9.47142C13.3965 9.47142 14.5286 10.6035 14.5286 12C14.5286 13.3965 13.3965 14.5286 12 14.5286Z" fill="url(#paint1_linear_4060_2829)"/>
<path d="M16.1461 8.88455C16.6938 8.88455 17.1377 8.4406 17.1377 7.89296C17.1377 7.34532 16.6938 6.90137 16.1461 6.90137C15.5985 6.90137 15.1545 7.34532 15.1545 7.89296C15.1545 8.4406 15.5985 8.88455 16.1461 8.88455Z" fill="url(#paint2_linear_4060_2829)"/>
<defs>
<linearGradient id="paint0_linear_4060_2829" x1="12" y1="19.9534" x2="12" y2="4.12427" gradientUnits="userSpaceOnUse">
<stop stop-color="#E09B3D"/>
<stop offset="0.3" stop-color="#C74C4D"/>
<stop offset="0.6" stop-color="#C21975"/>
<stop offset="1" stop-color="#7024C4"/>
</linearGradient>
<linearGradient id="paint1_linear_4060_2829" x1="12" y1="19.9534" x2="12" y2="4.12426" gradientUnits="userSpaceOnUse">
<stop stop-color="#E09B3D"/>
<stop offset="0.3" stop-color="#C74C4D"/>
<stop offset="0.6" stop-color="#C21975"/>
<stop offset="1" stop-color="#7024C4"/>
</linearGradient>
<linearGradient id="paint2_linear_4060_2829" x1="16.1461" y1="19.9535" x2="16.1461" y2="4.12433" gradientUnits="userSpaceOnUse">
<stop stop-color="#E09B3D"/>
<stop offset="0.3" stop-color="#C74C4D"/>
<stop offset="0.6" stop-color="#C21975"/>
<stop offset="1" stop-color="#7024C4"/>
</linearGradient>
</defs>
</svg>

  `,
  styles: []
})
export class InstagramIconComponent {}